exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  width: 300px;\n  padding: 10px;\n}\n.gx-custom-login-form .gx-login-content .ant-input {\n  padding: 12px;\n}\n@media screen and (min-width: 0px) and (max-width: 991px) {\n.gx-custom-login-form .gx-login-content .ant-input {\n    line-height: 2;\n    padding: 16px 18px;\n}\n.gx-custom-login-form .ant-btn {\n    padding: 16px 42px !important;\n    line-height: 2;\n}\n}", ""]);

// exports
